import { createContext, Dispatch, SetStateAction } from 'react';

interface HSAnalyticsContext {
  initialPageLoad: boolean;
  setInitialPageLoad: Dispatch<SetStateAction<boolean>>;
}
export const HSAnalyticsContext = createContext<HSAnalyticsContext>({
  initialPageLoad: false,
  setInitialPageLoad: () => {},
});
